import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React from 'react';
import { Button } from 'react-admin';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  to: string;
}

export const BackButton = ({ to }: BackButtonProps) => {
  const navigate = useNavigate();
  return (
    <Button
      label="ra.action.back"
      onClick={() => navigate(to)}
      sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
    >
      <ArrowBackIcon />
    </Button>
  );
};
